import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProfileTab from './tabs/ProfileTab';
import LocationsTab from './tabs/LocationsTab';
import AppointmentTypesTab from './tabs/AppointmentTypesTab';
import TeamTab from './tabs/TeamTab';
import RemindersTab from './tabs/RemindersTab';
import BillingSettings from '../billing/BillingSettings';
import CustomFieldsTab from './tabs/CustomFieldsTab';
import ProviderHoursTab from './tabs/ProviderHoursTab';
import NotificationsTab from './tabs/NotificationsTab';
import { useOrg } from '../../hooks/useOrg';
import { Building2, MapPin, CalendarClock, Users, Bell, CreditCard, Sliders, Clock, MessageSquare } from 'lucide-react';

const ALL_TABS = [
  { key: 'profile', label: 'Profile', Icon: Building2 },
  { key: 'locations', label: 'Locations', Icon: MapPin },
  { key: 'hours', label: 'Hours', Icon: Clock, medicalOnly: true },
  { key: 'appointment-types', label: 'Appt Types', Icon: CalendarClock },
  { key: 'team', label: 'Team', Icon: Users },
  { key: 'client-fields', label: 'Client fields', Icon: Sliders },
  { key: 'reminders', label: 'Reminders', Icon: Bell },
  { key: 'notifications', label: 'Texts', Icon: MessageSquare },
  { key: 'billing', label: 'Billing', Icon: CreditCard },
];

export default function OrgSettingsPage() {
  const { currentOrg } = useOrg();
  const TABS = ALL_TABS.filter((t) => !t.medicalOnly || currentOrg?.type === 'medical_practice');
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'profile');

  const switchTab = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  return (
    <div className="flex-1 bg-primary">
      <div className="max-w-[1200px] mx-auto px-4 md:px-7 py-6">
        <h1 className="text-[22px] font-bold text-primary-c mb-6">Organization Settings</h1>

        {/* Tabs */}
        <div className="flex bg-tertiary rounded-[10px] p-1 mb-6 overflow-x-auto">
          {TABS.map(t => (
            <button
              key={t.key}
              onClick={() => switchTab(t.key)}
              className={`shrink-0 md:flex-1 md:min-w-0 py-2.5 px-3.5 rounded-[7px] text-[13px] font-medium transition-all flex items-center justify-center gap-1.5 whitespace-nowrap ${
                activeTab === t.key
                  ? 'bg-accent text-white shadow-glow'
                  : 'text-muted-c hover:text-primary-c'
              }`}
            >
              <t.Icon size={14} strokeWidth={2.2} />
              <span className="md:truncate">{t.label}</span>
            </button>
          ))}
        </div>

        {activeTab === 'profile' && <ProfileTab />}
        {activeTab === 'locations' && <LocationsTab />}
        {activeTab === 'hours' && <ProviderHoursTab />}
        {activeTab === 'appointment-types' && <AppointmentTypesTab />}
        {activeTab === 'team' && <TeamTab />}
        {activeTab === 'client-fields' && <CustomFieldsTab />}
        {activeTab === 'reminders' && <RemindersTab />}
        {activeTab === 'notifications' && <NotificationsTab />}
        {activeTab === 'billing' && <BillingSettings />}
      </div>
    </div>
  );
}
